import React from 'react';
import { Section } from './ui/Section';
import { Zap, Target, Heart, Compass } from 'lucide-react';
export function Mechanism() {
  const pillars = [{
    icon: Zap,
    title: 'Energía',
    desc: 'Recuperación real, no fantasía'
  }, {
    icon: Target,
    title: 'Enfoque',
    desc: 'Cerrar pestañas mentales y empezar'
  }, {
    icon: Heart,
    title: 'Cuerpo',
    desc: 'Movimiento y comida simple, sin drama'
  }, {
    icon: Compass,
    title: 'Rumbo',
    desc: 'Decisiones pequeñas que sacan del estancamiento'
  }];
  return <div className="py-16 bg-white" data-id="element-43">
      <Section data-id="element-44">
        <h2 className="text-3xl md:text-4xl mb-12 text-center" data-id="element-45">
          Aquí está el mecanismo: <br data-id="element-46" />
          <span className="text-terracotta" data-id="element-47">Protocolo 4P + Versión 0.1</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-48">
          {pillars.map(p => <div key={p.title} className="p-6 rounded-xl bg-cream border border-cream-dark hover:border-terracotta/30 transition-colors" data-id="element-49">
              <div className="flex items-center gap-4 mb-3" data-id="element-50">
                <div className="p-3 bg-terracotta/10 rounded-lg text-terracotta" data-id="element-51">
                  <p.icon size={24} data-id="element-52" />
                </div>
                <h3 className="text-xl font-bold" data-id="element-53">{p.title}</h3>
              </div>
              <p className="text-brown-light" data-id="element-54">{p.desc}</p>
            </div>)}
        </div>

        <div className="space-y-8 text-lg text-brown/90" data-id="element-55">
          <p data-id="element-56">Pero la diferencia no son los pilares. La diferencia es esto:</p>

          <div className="bg-cream-dark p-8 rounded-2xl border-l-8 border-sage" data-id="element-57">
            <h3 className="text-2xl font-bold mb-4 text-sage-dark" data-id="element-58">
              La Versión 0.1
            </h3>
            <p className="mb-4" data-id="element-59">
              En vez de exigirte "hacerlo bien"… te enseña a hacer lo mínimo que
              cuenta.
            </p>
            <p className="mb-4" data-id="element-60">Para que en días malos:</p>
            <ul className="space-y-2 mb-6" data-id="element-61">
              <li className="flex items-center gap-2" data-id="element-62">
                <span className="text-sage-dark" data-id="element-63">✓</span> No te abandones
              </li>
              <li className="flex items-center gap-2" data-id="element-64">
                <span className="text-sage-dark" data-id="element-65">✓</span> No rompas la cadena
              </li>
              <li className="flex items-center gap-2" data-id="element-66">
                <span className="text-sage-dark" data-id="element-67">✓</span> No negocies tu
                identidad
              </li>
            </ul>
            <p className="font-medium italic" data-id="element-68">Mismo plan. Distinta potencia.</p>
          </div>

          <div className="pt-12" data-id="element-69">
            <h3 className="text-2xl font-bold mb-6" data-id="element-70">
              "¿Y si hago solo lo mínimo?"
            </h3>
            <p className="mb-6" data-id="element-71">
              Esa pregunta suena responsable… pero es tu culpa hablando. Porque
              tú no necesitas más exigencia.{' '}
              <span className="font-bold text-terracotta" data-id="element-72">Necesitas piso.</span>
            </p>
            <p data-id="element-73">
              La mayoría de la gente no fracasa por no hacer "mucho". Fracasa
              por dejar de hacer "algo". Con 0.1, "algo" se vuelve automático.
            </p>
          </div>
        </div>
      </Section>
    </div>;
}